import { Box, Drawer, Stack } from '@mui/material'
import React from 'react'
import { ReactQueryDevtools } from 'react-query/devtools'

import { DrawerGremlinLogoLink } from 'components/navigation/Nav/DrawerGremlinLogoLink'
import { DrawerUserInfo } from 'components/navigation/Nav/DrawerUserInfo'
import { NavItemList } from 'components/navigation/Nav/NavItemList'
import { muiTheme } from 'mui-theme'
import { colors } from 'mui-theme/theme'
import theme from 'theme'
import { isPrivateEdition } from 'utils/app-config'
import { isDevelopmentEnvironment } from 'utils/environment'

const wideDrawerWidth = 210
const narrowDrawerWidth = 80

const navBackgroundColor = colors.primary[900]

export const NavDrawer: React.FC<{
  children: React.ReactNode
  hasFaultInjection: boolean
  userHasTeams: boolean
}> = ({ children, hasFaultInjection, userHasTeams }) => {
  return (
    <Box
      sx={{
        display: 'flex'
      }}
    >
      <nav
        aria-label="main-navigation"
        css={{
          background: colors.primary[900],
          zIndex: theme.zIndices[5]
        }}
      >
        <Drawer
          css={[
            {
              width: narrowDrawerWidth,
              flexShrink: 0,
              whiteSpace: 'normal',
              boxSizing: 'border-box',
              transition: 'width 1s',

              [muiTheme.breakpoints.up('md')]: {
                width: wideDrawerWidth,
                transition: 'width 1s'
              }
            }
          ]}
          id="NavDrawer"
          open={true}
          sx={{
            '& .MuiDrawer-paper': {
              background: navBackgroundColor,
              width: narrowDrawerWidth,
              overflowX: 'hidden',
              transition: 'width 1s',

              [muiTheme.breakpoints.up('md')]: {
                width: wideDrawerWidth,
                transition: 'width 1s'
              }
            }
          }}
          variant="permanent"
        >
          <Stack
            css={{
              display: 'flex',
              flexDirection: 'column',
              flex: '1 1 auto'
            }}
          >
            <DrawerGremlinLogoLink
              url={hasFaultInjection ? '/' : '/services'}
            />
            <NavItemList userHasTeams={userHasTeams} />
            {isDevelopmentEnvironment() &&
              !isPrivateEdition() &&
              !window.Cypress && <ReactQueryDevtools initialIsOpen={false} />}
            <DrawerUserInfo
              css={{
                display: 'none',
                [muiTheme.breakpoints.up('md')]: {
                  display: 'unset'
                }
              }}
            />
          </Stack>
        </Drawer>
      </nav>
      {children}
    </Box>
  )
}
